// extracted by mini-css-extract-plugin
module.exports = {"FullWidthBanners__wrapper":"FullWidthBanners_FullWidthBanners__wrapper__eP3EI","FullWidthBanners__slide":"FullWidthBanners_FullWidthBanners__slide__A1cLF"};